import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  Inject,
  ViewChild,
  TemplateRef,
  AfterViewInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { TemplateService } from 'app/main/apps/template/template.service';
import { from, Observable, of, timer } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
} from 'rxjs/operators';
import { createUrlValidator } from 'app/shared/util/common-functions';

interface TemplateData {
  id: number;
  name: string;
  bodyText: string;
  botonUrl: string;
  category: string;
  labelUrl: string;
  language: string;
  footerText: string | null;
  headerText: string;
  parameter1Body: string;
  parameter2Body: string;
  parameter3Body: string | null;
}

@Component({
  selector: 'beplic-template-predefined-details',
  templateUrl: './template-predefined-details.component.html',
  styleUrls: ['./template-predefined-details.component.scss'],
})
export class TemplatePredefinedDetailsComponent implements OnInit, AfterViewInit {
  templateData: TemplateData | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() customize = new EventEmitter<void>();
  @Output() send = new EventEmitter<string>();

  isVisible: boolean = false; // ← Debe existir
  todoForm: FormGroup;

  templateName: string = '';
  botonUrl: string = '';
  activeTab: 'parameters' | 'example' = 'example';

  @ViewChild('alert', { static: true }) modalAlert: TemplateRef<any>;

  constructor(
    public dialogRef: MatDialogRef<TemplatePredefinedDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService,
    private fb: FormBuilder,
    public _templateService: TemplateService
  ) {}

  ngOnInit() {
    this.todoForm = this.fb.group({
      name: [
        this.templateName,
        {
          validators: [Validators.required, Validators.pattern('^[a-z0-9_]+$')],
          asyncValidators: [
            // Validadores asíncronos
            existingNameValidator(this._templateService),
          ],
          //updateOn: 'blur'
        },
      ],
      url: [
        this.botonUrl,
        [Validators.required, createUrlValidator({ rejectWhatsAppUrls: true })],
      ],
    });
  }

  ngAfterViewInit(): void {
    if (this.data) {
      this.todoForm.get('name').setValue('');
      this.todoForm.get('url').setValue('');
      this.templateData = this.data;
      this.validateKey();
      this.todoForm.markAllAsTouched();
    }
  }

  get name() {
    return this.todoForm.get('name');
  }

  get url() {
    return this.todoForm ? this.todoForm.get('url') : null;
  }

  closeModal(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    this.close.emit();
  }

  customizeTemplate() {
    this.dialogRef.close({ personalizado: true, template: this.templateData });
  }

  sendTemplate() {
    if (this.todoForm.valid) {
      this.templateData.name = this.todoForm.get('name').value;
      this.templateData.botonUrl = this.todoForm.get('url').value;
      this.dialogRef.close({ personalizado: false, template: this.templateData });
    }
  }

  getProcessedBodyText(): string {
    if (!this.templateData) return '';

    let processedText = this.templateData.bodyText;

    // Reemplazar parámetros con valores reales
    if (this.templateData.parameter1Body) {
      processedText = processedText.replace(
        /\{\{1\}\}/g,
        this.templateData.parameter1Body
      );
    }
    if (this.templateData.parameter2Body) {
      processedText = processedText.replace(
        /\{\{2\}\}/g,
        this.templateData.parameter2Body
      );
    }
    if (this.templateData.parameter3Body) {
      processedText = processedText.replace(
        /\{\{3\}\}/g,
        this.templateData.parameter3Body
      );
    }

    return processedText;
  }

  getCurrentTime(): string {
    const now = new Date();
    return now.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  }

  validateKey() {
    this._templateService.validateKey(this.todoForm.get('name').value).then(data => {
      console.log(data);
      if (data) {
      }
    });
  }
}

export function existingNameValidator(
  templateService: TemplateService
): AsyncValidatorFn {
  // La función que devuelve es el validador real
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value) {
      return of(null);
    }

    return from(templateService.validateKey(control.value)).pipe(
      map(keyExists => {
        return keyExists ? { nameExists: true } : null;
      }),
      catchError(() => of(null))
    );
  };
}

export function existingNameValidator1(
  templateService: TemplateService
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value) {
      return of(null); // Si no hay valor, no valides
    }

    return control.valueChanges.pipe(
      // 1. Espera 500ms después de la última pulsación antes de continuar
      debounceTime(500),

      // 2. Solo continúa si el valor nuevo es diferente al anterior
      distinctUntilChanged(),

      // 3. Llama a tu servicio y cancela llamadas anteriores si hay una nueva
      switchMap(value => templateService.validateKey(value)),

      // 4. Mapea la respuesta
      map(nameExists => (nameExists ? { nameExists: true } : null)),

      // 5. Maneja errores de la API
      catchError(() => of(null))
    );
  };
}
